import React from 'react';
import { strFormat } from '../../../helpers/utils';

export const actionType = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
  CLEAR: 'CLEAR',
  SET_VALUE: 'SET_VALUE',
};

export const guestsSelectorStateCheck = (state, action) => {
  if (action.type === actionType.DECREASE) {
    if (action.field === 'adults') {
      return state.adults > 1 || state.children + state.infants === 0;
    }
    return state[action.field] > 0;
  }
  if (action.type === actionType.CLEAR) {
    return state.adults + state.children + state.infants !== 0;
  }
  return true;
};

export const guestsSelectorReducer = (state, action) => {
  if (!guestsSelectorStateCheck(state, action)) {
    return state;
  }
  switch (action.type) {
    case actionType.INCREASE: {
      const adults = action.field !== 'adults' && state.adults === 0 ? 1 : state.adults;
      return { ...state, adults, [action.field]: state[action.field] + 1 };
    }
    case actionType.DECREASE:
      return { ...state, [action.field]: state[action.field] - 1 };
    case actionType.CLEAR:
      return { adults: 0, children: 0, infants: 0 };
    case actionType.SET_VALUE:
      return action.value;
    default:
      return state;
  }
};

/**
 * Render prop wrapper around the guestsSelectorReducer for use in class components.
 */
export function GuestsSelectorContainer({ initialValue, children }) {
  const reducer = React.useReducer(guestsSelectorReducer, initialValue);
  return children(reducer);
}

export function getInputText(translate, { adults, children, infants }) {
  const guestsCount = adults + children;
  const inputText =
    infants > 0
      ? translate('cmp-guests-input-text', '{0} Guests, {1} Infants')
      : translate('cmp-guests-adults-input-text', '{0} Guests');
  return strFormat(inputText, [guestsCount, infants]);
}
